import { observer } from "mobx-react-lite";
import { FC } from "react";
import styled from "@emotion/styled";
import { AppCalloutBannerInlineAction } from "@/components/banners/app-callout-banner/app-callout-banner-inline-action";
import { MDSText, MDSTextVariant, MDSTextColor } from "@/mds";

interface AppCalloutBannerSecondaryLabelProps {
  label: string;
  inlineActionLabel: string | null;
  inlineActionUrl: string | null;
}

export const AppCalloutBannerSecondaryLabel: FC<AppCalloutBannerSecondaryLabelProps> = observer(
  ({ label, inlineActionLabel, inlineActionUrl }) => {
    if (!label) return null;

    return (
      <SecondaryLabelText variant={MDSTextVariant.TextS} color={MDSTextColor.Secondary}>
        {label}
        <AppCalloutBannerInlineAction label={inlineActionLabel} url={inlineActionUrl} />
      </SecondaryLabelText>
    );
  }
);

const SecondaryLabelText = styled(MDSText)`
  margin-bottom: 8px;
`;
